module.exports = __webpack_public_path__ + "media/ibra11-1.4dbee613.mp3";